import React from 'react';
import cx from 'classnames';
import DraggableLayer from 'cards/components/Customization/Preview/DraggableLayer';
import SelectableImageLayer from 'cards/components/Customization/Preview/SelectableImageLayer';
import QRDeleteButton from 'cards/components/Customization/common/CustomizationSidePanel/QRDeleteButton';
import FeatureFlags from 'util/featureFlags';
import { pxToPt } from '../../../util';

import './TextLayer.less';

const DraggableImageLayer = ({
  imageElement,
  isActive,
  parentDimensions,
  handleChange,
  isReviewStep,
  editable,
  ...rest
}) => {
  const handleDragStop = deltas => {
    // group changes in an array so that undo functionality knows to undo each field changed
    // at the same time, this is especially important for moving/resizing because the changes
    // only make sense when grouped together - dont want users undoing one change without undoing
    // the others. For example, if an element was dragged horizontally, we want to be able to undo both
    // the x and y position changes at the same time, otherwise user would have to click 'undo' twice before
    // getting the element back to the original position
    const changes = [
      {
        elementUUID: imageElement.uuid,
        fieldName: 'x',
        value: imageElement.x + pxToPt(deltas.left),
      },
      {
        elementUUID: imageElement.uuid,
        fieldName: 'y',
        value: imageElement.y + pxToPt(deltas.top),
      },
      {
        elementUUID: imageElement.uuid,
        fieldName: 'width',
        value: imageElement.width - pxToPt(deltas.right) - pxToPt(deltas.left),
      },
      {
        elementUUID: imageElement.uuid,
        fieldName: 'height',
        value: imageElement.height - pxToPt(deltas.bottom) - pxToPt(deltas.top),
      },
    ];
    // for text elements like rsvp/meal options where there is a bullet point image next to the line,
    // make sure to also update the position of that linked image element with the new coordinates
    // so that user does not have to drag both text and image elements and align them again
    // const linkedElement = _find(customizationValues, { linked_element_uuid: imageElement.uuid });
    // if (linkedElement) {
    //   // no need to update width/height of image elements, only update based on top/left deltas of text element
    //   // if the text element is resized to the bottom/right the linked element position does not get updated
    //   changes = [
    //     ...changes,
    //     { elementUUID: linkedElement.uuid, fieldName: 'x', value: linkedElement.x + pxToPt(deltas.left) },
    //     { elementUUID: linkedElement.uuid, fieldName: 'y', value: linkedElement.y + pxToPt(deltas.top) },
    //   ];
    // }
    handleChange(changes);
  };

  const { x, y, width, height } = imageElement;
  const outerImageLayerStyles = {
    position: 'absolute',
    top: `${y}pt`,
    left: `${x}pt`,
    width: `${width + pxToPt(2)}pt`,
    height: `${height + pxToPt(2)}pt`,
    zIndex: isActive ? 1500 : Math.max(Math.floor(y), 10),
  };

  return (
    <DraggableLayer
      element={imageElement}
      style={outerImageLayerStyles}
      className={cx('image-layer-container', {
        isEditable: !isReviewStep,
      })}
      isActive={isActive}
      parentDimensions={parentDimensions}
      dragStopCallback={handleDragStop}
      disabled={!editable || isReviewStep}
    >
      {(deltas, dragging, dragHandle) => (
        <>
          <SelectableImageLayer
            {...rest}
            imageElement={imageElement}
            isActive={isActive}
            deltas={deltas}
            dragging={dragging}
            dragHandle={dragHandle}
            isDisabled={isReviewStep}
          />
          {!isReviewStep && !FeatureFlags.get('newPaperShapes') && (
            <QRDeleteButton editable={editable && isActive} />
          )}
        </>
      )}
    </DraggableLayer>
  );
};

export default DraggableImageLayer;
